import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@babackapp/ui/components/select";
import { FormField } from "@babackapp/ui/components/form";
import { PanelInlineContent } from "../../lib/panel/panel-inline-content";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import { useNodeFormPath } from "../../hooks/use-node-form-path";
import { useTranslation } from "react-i18next";
import { ContextualTipsTrigger } from "@babackapp/ui/components/contextual-tips";


export function PanelOperator() {
  const form = useWorkflowForm();
  const operatorPath = useNodeFormPath("operator");
  const { t } = useTranslation("trackoffice");

  if (!operatorPath) return null;

  return (
    <PanelInlineContent title={t("workflowsEditor.node.condition.operatorTitle", "Logic operator")}>
      <ContextualTipsTrigger wrapped tips={[
        {
          id: "workflow-condition-operator",
          title: t(
            "workflowsEditor.tips.conditionOperator.title",
            "Condition operator",
          ),
          description: t(
            "workflowsEditor.tips.conditionOperator.description",
            "This defines how the conditions should be combined. You can choose between AND (all conditions must match) and OR (at least one condition must match).",
          ),
        },
      ]}>
      <FormField
        control={form.control}
        name={operatorPath}
        render={({ field }) => (
          <Select value={field.value as string} onValueChange={field.onChange}>
            <SelectTrigger className="w-[80px] h-8 text-xs">
              <SelectValue>
                {t(`workflowsEditor.node.condition.operator.${(field.value as string || 'and').toLowerCase()}`, "AND")}
              </SelectValue>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="AND">
                <div className="flex flex-col gap-1">
                  <span className="text-xs">
                    {t("workflowsEditor.node.condition.operator.and", "AND")}
                  </span>
                  <span className="text-[10px] text-muted-foreground">
                    {t("workflowsEditor.node.condition.operator.andDescription", "All conditions must match")}
                  </span>
                </div>
              </SelectItem>
              <SelectItem value="OR">
                <div className="flex flex-col gap-1">
                  <span className="text-xs">
                    {t("workflowsEditor.node.condition.operator.or", "OR")}
                  </span>
                  <span className="text-[10px] text-muted-foreground">
                    {t("workflowsEditor.node.condition.operator.orDescription", "At least one condition must match")}
                  </span>
                </div>
              </SelectItem>
            </SelectContent>
          </Select>
        )}
      />
      </ContextualTipsTrigger>
    </PanelInlineContent>
  );
}
